import SecureLS from 'secure-ls'
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import PermissionError from '../components/GeneralViews/PermissionError.vue'
// Dashboard pages
// const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview2.vue')
const Widgets = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Widgets.vue')

// User pages
const Users = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Users/Users.vue')


// Parametrization pages
const ActivityTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/ActivityTypes.vue')
const AnalystTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/AnalystTypes.vue')
const CreditPurposes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/CreditPurposes.vue')
const Catalogs = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Catalogs.vue')
const CreditRequestStages = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/CreditRequestStages.vue')
const CreditTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/CreditTypes.vue')
const ClientTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/ClientTypes.vue')
const AccountTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/AccountTypes.vue')
const FinancialObligationTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/FinancialObligationTypes.vue')
const AmountYTermsWC = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/AmountsYTermsWC.vue')
const AmountYTermsFA = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/AmountsYTermsFA.vue')
const ContingentQuotaTDCAgro = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/ContingentQuotaTDCAgro.vue')
const ContingentQuotaTDCPyme = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/ContingentQuotaTDCPyme.vue')
const CreditRate = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/CreditRate.vue')
const Commission = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Commission.vue')
const IdentificationDocumentTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/IdentificationDocumentTypes.vue')
const Offices = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Offices.vue')
const ProductTypes = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/ProductTypes.vue')
const Regionals = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Regionals.vue')
const Settings = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Settings.vue')
const Permissions = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/Permissions.vue')
const AnalystOffice = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Parametrizations/AnalystOffice.vue')

// Logs pages
const OnlineUsers = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Logs/OnlineUsers.vue')
const SystemLogging = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Logs/SystemLogging.vue')
const ErrorLogging = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Logs/ErrorLogging.vue')

//Assessments pages
const Assessments = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Assessments/Assessments.vue')


// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import PasswordChange from 'src/components/Dashboard/Views/Pages/Password/PasswordChange.vue'
import PasswordReset from 'src/components/Dashboard/Views/Pages/Password/PasswordReset.vue'
import PasswordResetEnd from 'src/components/Dashboard/Views/Pages/Password/Reset.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
const RegularForms  = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/Wizard.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/RegularTables.vue');
const ExtendedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/ExtendedTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue');

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')
const permissions = new SecureLS({encodingType: 'aes'});
// const permissions_array = permissions.get('permissions').data;
let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let passwordChange = {
  path: '/password_change',
  name: 'PasswordChange',
  component: PasswordChange
}

let passwordReset = {
  path: '/reset_password/:user_id/:token',
  name: 'PasswordReset',
  component: PasswordReset
}

let passwordResetEnd = {
  path: '/reset',
  name: 'PasswordResetEnd',
  component: PasswordResetEnd
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'users',
        name: 'Usuarios',
        component: Users,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_office") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/regionals',
        name: 'Regionales',
        component: Regionals,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_regional") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/offices',
        name: 'Oficinas',
        component: Offices,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_office") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/analyst_types',
        name: 'Tipos de Analista',
        component: AnalystTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_analysttype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/credit_request_stages',
        name: 'Etapas del crédito',
        component: CreditRequestStages,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_creditrequeststage") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/product_types',
        name: 'Tipos de producto',
        component: ProductTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_producttype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/credit_types',
        name: 'Tipos de crédito',
        component: CreditTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/client_types',
        name: 'Tipos de clientes',
        component: ClientTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/account_types',
        name: 'Tipos de cuentas',
        component: AccountTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/financial_obligation_types',
        name: 'Tipos de obligación financiera',
        component: FinancialObligationTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/amount_terms_wc',
        name: 'Montos y plazos - CT',
        component: AmountYTermsWC,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/amount_terms_fa',
        name: 'Montos y plazos - AF',
        component: AmountYTermsFA,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/contingent_quota_tdc_agro',
        name: 'Cuota contingente - Agro',
        component: ContingentQuotaTDCAgro,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/contingent_quota_tdc_pyme',
        name: 'Cuota contingente - Pyme',
        component: ContingentQuotaTDCPyme,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/credit_rate',
        name: 'Tasas de crédito',
        component: CreditRate,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/commission',
        name: 'Comisiones',
        component: Commission,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_credittype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/identification_document_types',
        name: 'Tipos de documento',
        component: IdentificationDocumentTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_identificationdocumenttype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/activity_types',
        name: 'Tipos de actividad',
        component: ActivityTypes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_activitytype") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/credit_purposes',
        name: 'Destinos del crédito',
        component: CreditPurposes,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_creditpurpose") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/catalog_percent',
        name: 'Porcentaje de catálogos',
        component: Catalogs,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_creditpurpose") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/settings',
        name: 'Variables del sistema',
        component: Settings,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_systemsettings") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'parametrizations/permissions',
        name: 'Roles y permisos',
        component: Permissions,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_group") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'logs/online_users',
        name: 'Usuarios conectados',
        component: OnlineUsers,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_session") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'logs/system_logging',
        name: 'Ingresos al sistema',
        component: SystemLogging,
        beforeEnter: (to, from, next) => {
          if(permissions.get('permissions').data.indexOf("view_accessattempt") > -1) next()
          else next('/401');
        }
      },
      {
        path: 'assessments/assessments',
        name: 'Evaluaciones',
        component: Assessments,
      },
      
    ]
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  loginPage,
  passwordChange,
  passwordReset,
  passwordResetEnd,
  registerPage,
  lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      },
      
    ]
  },
  {path: '/401', name: 'PermissionError',component: PermissionError},
  {path: '*', component: NotFound}
];

export default routes
